import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for comparison type changes
    const comparisonTypeSelect = document.querySelector('[data-comparison-type]');
    if (comparisonTypeSelect) {
      comparisonTypeSelect.addEventListener('change', this.handleComparisonTypeChange.bind(this));
    }
  }

  handleComparisonTypeChange(event) {
    // The overlay is already shown by the onchange handler in the view
    const comparisonType = event.target.value;
    const form = event.target.closest('form');
    
    // Clear any existing item selection from other types
    const hiddenFields = form.querySelectorAll('input[type="hidden"]');
    hiddenFields.forEach(field => {
      if (field.name.endsWith('_id') && field.name !== 'benchmark_id') {
        field.remove();
      }
    });
    
    // Submit the form to reload with new comparison type
    form.submit();
  }
}